"use strict";
/**
 * 德邦LODOP客户端打印插件
 * @author Created by 348776 on 2018/04/13.
 * @contacts QQ:11341684
 * @version 4.0.0
 */
import {getLODOP,getCLODOP} from './getLODOP';
import Util from './util';
import renderConfig from './renderConfig';
import Promise from 'es6-promise'
/*;*/
import JsBarcode from 'jsbarcode'
import Qrcode from 'qrious';
/**
 * 插入LODOP中间件js文件。
 * @param driveURL {string|Array|null|undefined} 依次解析url，成功一个即返回。
 * @return {Promise}
 */
window.Promise=window.Promise||Promise;
let buildLODOP = (driveURL,timeOutNumber=4000)=>{
    return new Promise((resolve,reject)=>{
        let isHttps=/https/.test(location.protocol);
        if(typeof driveURL ==='string'){
            driveURL=[driveURL]
        }
        function getScript(index) {
            if(!driveURL[index]){
                const ERRORTEXT='没有检测到LODOP,请确保LODOP已经是开启状态！';
                if(isHttps){
                    reject(ERRORTEXT+"如果你已经开启LODOP,可能版本过低，需要升级到支持https的版本");
                }else {
                    reject("端口可能被占用，或者是网络问题！")
                }
            }else {
                if(isHttps&&!/^https/.test(driveURL[index])){
                    return getScript(index+1);
                }
                let isErrored=false;
                let script=document.createElement('script');
                let head = document.head || document.getElementsByTagName('head')[0] || document.documentElement;
                let clear=()=>{
                    if(isErrored)return 1;
                    isErrored=1;
                    script.onerror=script.onload=null;
                    head.removeChild(script);
                    return 0
                };
                let onload=()=>{!clear()&&resolve();};
                let onerror=()=>{
                    !clear()&&getScript(index+1);
                };
                script.onload=onload;
                script.onerror=onerror;
                script.src=driveURL[index];
                head.insertBefore(script,head.firstChild);
                setTimeout(onerror,timeOutNumber)
            }
        }
        getScript(0);
    })
};
const DispatcherEventPool=[];
class Dispatcher {
    id=null;
    constructor(option){
        this.id=option.id||'';
    }
    on(type,callback,once,stop){
        return Dispatcher.on(type,this.id,callback,once,stop);
    }
    emit(type,data){
        return Dispatcher.emit(type,data,this.id,this);
    }

    off(type,callback){
        return Dispatcher.off(type,this.id,callback);
    }
    getEvents(type){
        return Dispatcher.getEvents(type,this.id);
    }
    once(type,callback,stop){
        return Dispatcher.once(type,this.id,callback,stop);
    }
    emitAsync(type,data){
        return Dispatcher.emitAsync(type,data,this.id);
    }
    onByObject(option,clipping=true){
        if(!Util.isObject(option))return false;
        for(let key in option){
            if(!option.hasOwnProperty(key)) continue;
            if(Util.isFunction(option[key])){
                this.on(key,option[key]);
                if(clipping){
                    delete option[key]
                }
            }else if(Util.isObject(option[key])){
                this.onByObject(option[key],clipping);
            }
        }
    }
    static emitAsync(type,data,name,scope){
        const results=Dispatcher.emit(type,data,name,scope);
        const promises=[];
        for(let i=0;i<results.length;i++){
            let p=results[i];
            if(p&& p.then){
                promises.push(p)
            }
        }
        if(promises.length===0){
            return new Promise((resolve)=>{
                resolve(results);
            })
        }else {
            return Promise.all(promises)
        }
    }
    static once(type,name,callback,stop){
        return Dispatcher.on(type,name,callback,true,stop);
    }
    static on(type,name,callback,once=false,stop=false){
        let opt=type;
        const $events=DispatcherEventPool;
        if(typeof type==='string'){
            opt={};
            opt.type=type;
            if(typeof name ==='string'||Util.isFunction(callback)){
                opt.name=name;
                opt.callback=callback
            }else {
                opt.callback=name
            }
            opt.once=once;
            opt.stop=stop;
        }
        if(!opt.name){
            opt.name=this.id;
        }
        if(!Util.isFunction(opt.callback))return false;
        if(!opt.type||typeof opt.type!=='string')return false;
        for(let i=0,len=$events.length;i<len;i++){
            if(opt.name&&$events[i].name&&opt.name===$events[i].name&&opt.type===$events[i].type&&opt.callback===$events[i].callback){
                return false
            }
        }
        $events.push(opt);
        return true
    }
    static emit(type,data,name,scope){
        let result=[];
        if(!type)return result;
        if(!name){
            name=this.id;
        }
        scope=scope||this;
        const $events=DispatcherEventPool;
        let stop=false;
        for(let i=0,len=$events.length;i<len;i++){
            let currentEvent=$events[i];
            if(type===currentEvent.type&&(!(name&&currentEvent.name&&currentEvent.name!==name))){
                result.push(currentEvent.callback.call(scope,data));
                if(currentEvent.once===true){
                    setTimeout(()=>{Dispatcher.off(currentEvent.type,currentEvent.name,currentEvent.callback)},0)
                }
                if(currentEvent.stop===true){
                    stop=true
                }
            }
        }
        let _eventNames;
        if(stop===false&&name&&(_eventNames=name.split('.'))&&_eventNames.length>1){
            result=result.concat(Dispatcher.emit(type,data,_eventNames.slice(0,-1).join('.'),scope));
        }
        return result;
    }
    static off(type,name,callback){
        let number=0;
        if(arguments.length===0){
            number=DispatcherEventPool.length;
            DispatcherEventPool.splice(0,number);
            return number
        }
        let opt={};
        if(Util.isObject(type)){
            opt=type
        }else {
            if(typeof name==='string'||Util.isFunction(callback)){
                opt.type=type;
                opt.name=name;
                opt.callback=callback;
            }else {
                opt.callback=name
            }
        }
        for(let i=0;i<DispatcherEventPool.length;i++){
            if(!(opt.name&&DispatcherEventPool[i].name&&opt.name!==DispatcherEventPool[i].name||(opt.type&&DispatcherEventPool[i].type&&opt.type!==DispatcherEventPool[i].type))){
                if(!opt.callback||opt.callback===DispatcherEventPool[i].callback){
                    number++;
                    DispatcherEventPool.splice(i,1);
                    i--;
                }
            }
        }
        return number;
    }
    static getEvents(type,name){
        const newEvent=[];
        if(!type||!name)return newEvent;
        const $events=DispatcherEventPool;

        for(let i=0;i<$events.length;i++){
            if($events[i].name===name&&$events[i].type===type){
                newEvent.push($events[i]);
            }
        }
        return newEvent
    }
}
class Task extends Dispatcher {
    static tasks=[];
    static QI={//queueInfomation
        currentIndex:0,
        idle:true,
        queues:[]
    };
    static queue(task,head){
        if(!(task instanceof Task))return false;
        const index=Task.getQueueIndex(task);
        const queues=Task.QI.queues;
        if(index===-1){
            queues.push({printer:task.printer,tasks:[task]});
        }else {
            let i=!head&&queues[index].tasks.length||0;
            queues[index].tasks.splice(i,0,task);
        }
        if(Task.QI.idle){
            Task.QI.idle=false;
            task.start();
        }
    }
    static dequeue(task){
        Task.QI.idle=true;
        if(!(task instanceof Task))return false;
        let index=Task.getQueueIndex(task);
        const queues=Task.QI.queues;
        if(index!==-1){
            let tasks=queues[index].tasks;
            for(let i=0;i<tasks.length;i++){
                if(tasks[i]&&tasks[i]===task){
                    tasks.splice(i,1);
                    let _index=Task.QI.currentIndex;
                    if(tasks.length===0){
                        queues.splice(index,1);
                        _index--;
                    }
                    _index++;
                    if(_index>=queues.length){
                        _index=0;
                    }
                    if(queues[_index]){
                        Task.QI.idle=false;
                        Task.QI.currentIndex=_index;
                        queues[_index].tasks[0].start();
                    }
                    break;
                }
            }
        }
    }
    static getQueueIndex(task){
        const printer=task.printer;
        for(let i=0;i<Task.QI.queues.length;i++){
            if(Task.QI.queues[i].printer===printer){
                return i
            }
        }
        return -1;
    }
    constructor(option){
        super(...arguments);
        Task.checkAndInit(option);
        this.prevId=option.prevId;
        let id=Util.getId();
        if(this.prevId){
            id=this.prevId+"."+id
        }
        this.config=option.config||{};
        this.id=id;
        this.parentId=option.parentId||null;
        this.startTime=null;
        this.endTime=null;
        this.completeTime=null;
        this.success=null;
        this.status=option.status||0;
        this.data=option.data;

        this.dependency=option.dependency;
        this.index=option.index;
        this.templateName=option.templateName;
        this.printer=option.printer;
        this.type=Task.getType(option.type);
        this.taskId=null;
        this.batchId=option.batchId||null;
        this.enableDetach=typeof option.enableDetach==='undefined'&&true||Boolean(option.enableDetach);

        this.onByObject(option);
        Task.tasks.push(this);
        this.setStatus(0);
        this.emit('taskInit',this);
    }
    static types=['PRINT','PREVIEW','PRINT_DESIGN'];
    static getType(type){
        if(!isNaN(type)){
            return Number(type)
        }
        if(!type){
            return 0
        }
        for(let i=0;i<Task.types.length;i++){
            if(Task.types[i]===type){
                return i
            }
        }
        return 0
    }
    static checkAndInit(option){
        if(!(option.dependency instanceof Task)){
            option.dependency=null;
        }
        return option
    }
    getBeDependency(task=this){
        const newTasks=[];
        const tasks=Task.tasks;
        for(let i=0,len=tasks.length;i<len;i++){
            if(tasks[i].dependency===task){
                newTasks.push(tasks[i]);
            }
        }
        return newTasks
    }
    insert(tasks){
        if(tasks instanceof Task){
            tasks=[tasks]
        }else if(!tasks||tasks.length===0){
            return false;
        }
        const first=tasks[0];
        const last=tasks[tasks.length-1];
        const beDependences=this.getBeDependency();
        for(let i=0,len=beDependences.length;i<len;i++){
            beDependences[i].dependency=last
        }
        first.dependency=this;
        for(let i=1,len=tasks.length;i<len;i++){
            tasks[i].dependency=tasks[i-1];
        }
        return tasks;
    }
    detachData(task=this,status){
        if(!(task instanceof Task))return false;
        if(!task.enableDetach||task.type!==0)return false;
        let data=task.data;
        if(!Util.isArray(data))return false;
        const splitLength=task.splitLength||task.config.splitLength;
        if(!this.isBigger(data,splitLength))return false;
        const newTasks=[];
        const len = data.length;
        task.data=data.slice(0,splitLength);
        for (let i=1,_len=Math.ceil(len/splitLength);i<_len;i++){
            newTasks.push(new Task(Object.assign({},this.copy(),{
                data:data.slice(i*splitLength,(i+1)*splitLength>len&&len||(i+1)*splitLength),
                templateName:task.templateName,
                printer:task.printer,
                type:task.type,
                parentId:task.id,
                index:task.index+'.'+(i),
                status
            })));
        }
        if(newTasks.length>1){
            const events=task.getEvents("taskComplete");
            const last=newTasks[newTasks.length-1];
            this.off("taskComplete");
            for(let i=0;i<events.length;i++){
                last.on("taskComplete",events[i]);
            }
        }
        return newTasks
    }
    start(task=this){
        task.setStatus(2);
        task.emit("taskStart",task);
        task.startTime=new Date().getTime();
        if(task.config.notUseLODOP){
            task.windowPrintTask(task);
        }else {
            task.printTask(task);
        }
    }
    end(task=this){
        task.endTime=new Date().getTime();
        const tasks=this.getBeDependency();
        for(let i=tasks.length-1;i>-1;i--){
            if(tasks[i].status===1){
                Task.queue(tasks[i],true);
            }
        }
        setTimeout(()=>{
            Task.dequeue(task);
        },0)
    }
    complete(task=this,printNumber){
        task.returnValue=printNumber;
        if(!printNumber||printNumber===0){
            task.setStatus(13);
            task.emit("taskCancelPrint",task);
        }else {
            task.setStatus(12);
            task.success=true;
            task.emit("taskSuccess",task);
        }
        task.emitComplete();
    }
    isComplete(task=this){
        return task.status===15;
    }
    isBigger(data=this.data,length){
        return data&&data.length>length;
    }
    setStatus(number){
        number=Task.getStatus(number);
        let min=0,max=Task.statusAll.length-1;
        if(number<0||number>max){
            throw new Error("setStatus参数只能为数字(大于等于"+min+"与小于等于"+max+")或者可识别的字符串");
        }
        this.status=number;
    }
    static statusAll=["Init","Ready","Start","BeforeSetPrinter","BeforeSetTemplate","BeforeDetach","AfterDetach","BeforeRender","BeforeSingleRender","AfterRender","BeforeSendPrinter","AfterSendPrinter","Success","CancelPrint","ErrorPrint","Complete"];
    static getStatus(number){
        if(isNaN(number)){
            if(typeof number==="string"){
                number=Util.inArray(number,Task.statusAll);
            }else {
                number=-1;
            }
        }
        return Number(number)
    }
    copy(){
        const {prevId,status,templateName,printer,type,batchId}=this;
        return {
            prevId,status,templateName,printer,type,batchId
        }
    }
    printTask(task=this){
        if(!(task instanceof Task)){
            throw new Error('print函数只能传入Task类');
        }
        this.setPrinter().then(()=>{
            return this.setTemplate(task);
        }).then(()=>{
            task.setStatus(5);
            return this.emitAsync('taskBeforeDetach',task);
        }).then(()=>{
            task.emit("detachData",{tasks:task.detachData(task),task:task});
            task.setStatus(6);
            return this.emitAsync('taskAfterDetach',task);
        }).then(()=>{
            const templateName=task.templateName;
            let template=Template.getTemplate(templateName);
            if(!(template instanceof Template)){
                return Promise.reject("模版不符合条件或者为空");
            }
            return template.renderTask(task,Print.LODOP);
        }).then(()=>{
            task.setStatus(10);
            return task.emitAsync("taskBeforeSendPrinter",task)
        }).then(()=>{
            if(Print.LODOP.CVERSION){
                this.CLODOPPrint(task)
            }else{
                this.LODOPPrint(task)
            }
            task.setStatus(11);
            return task.emitAsync("taskAfterSendPrinter",task);
        }).then(()=>{
            task.end();
        }).catch(errorText=>{
            task.emitError(task,errorText);
        });
    }
    windowPrintTask(task=this){
        if(!(task instanceof Task)){
            throw new Error('print函数只能传入Task类');
        }
        this.setTemplate(task).then(()=>{
            return new WindowLODOP(task).onReady();
        }).then(LODOP=>{
            const templateName=task.templateName;
            let template=Template.getTemplate(templateName);
            if(!(template instanceof Template)){
                return Promise.reject("模版不符合条件或者为空");
            }
            return template.renderTask(task,LODOP);
        }).then(()=>{
            task.setStatus(10);
            return task.emitAsync("taskBeforeSendPrinter",task)
        }).then(()=>{
            this.windowPrint(task);
            task.setStatus(11);
            return task.emitAsync("taskAfterSendPrinter",task);
        }).then(()=>{
            task.end();
        }).catch(errorText=>{
            task.emitError(task,errorText);
        });
    }
    emitError(task=this,errorText){
        task.setStatus(14);
        task.emit("taskErrorPrint",errorText);
        task.emitComplete();
    }
    emitComplete(task=this){
        task.setStatus(15);
        task.emit("taskComplete",task);
        task.completeTime=new Date().getTime();
    }
    setPrinter(task=this){
        return new Promise(reslove=>{
            task.setStatus(3);
            this.emitAsync('taskBeforeSetPrinter',task).then((printer)=>{
                if(Util.isArray(printer)){
                    printer=printer[0];
                }
                task.printer=typeof printer==='string'&&printer||task.printer||task.config.printer;
                reslove(task)
            });
        })
    }
    setTemplate(task=this){
        return new Promise((reslove)=>{
            task.setStatus(4);
            this.emitAsync('taskBeforeSetTemplate',task).then((templateName)=>{
                if(Util.isArray(templateName)&&templateName.length>0){
                    templateName=templateName[0];
                }
                templateName=typeof templateName==='string'&&templateName||task.templateName||task.config.templateName;
                task.templateName=templateName;
                reslove(task)
            });
        })
    }
    CLODOPPrint(task=this){
        let TaskID;
        Print.LODOP.SET_PRINTER_INDEX(task.printer);
        switch (task.type){
            case 0:
                TaskID=Print.LODOP.PRINT();
                break;
            case 1:
                TaskID=Print.LODOP.PREVIEW();
                break;
            case 2:
                TaskID=Print.LODOP.PRINT_DESIGN();
                break;
            default:
                TaskID=Print.LODOP.PRINT();
                break;
        }
        task.taskId=TaskID||Util.getId('CLODOP!');
        return TaskID;
    }
    LODOPPrint(task=this){
        let TaskID=Util.getId('LODOP!'),printNumber;
        Print.LODOP.SET_PRINTER_INDEX(task.printer);
        switch (task.type){
            case 0:
                printNumber=Print.LODOP.PRINT();
                break;
            case 1:
                printNumber=Print.LODOP.PREVIEW();
                break;
            case 2:
                Print.LODOP.PRINT_DESIGN();
                printNumber=false;
                break;
            default:
                printNumber=Print.LODOP.PRINT();
                break;
        }
        task.taskId=TaskID;
        setTimeout(()=>{Print.onReturn(TaskID,printNumber)},0);
        return TaskID
    }
    windowPrint(task=this){
        let TaskID=Util.getId('window!');
        const id=task.LODOP.iframeId;
        const $iframe=document.getElementById(id);
        if(!$iframe){
            throw new Error("获取不到打印的iframe");
        }
        task.taskId=TaskID;
        task.LODOP.removeLastEmptyPage();
        setTimeout(()=>{
            $iframe.contentDocument.close();
            window.frames[id].focus();
            try {
                window.frames[id].print();
            }catch (err){
                $iframe.contentWindow.print();
            }
            setTimeout(function () {
                task.LODOP=null;
                $iframe.parentNode.removeChild($iframe);
            },1000);
            Print.onReturn(TaskID,true)
        },100);
        return TaskID
    }
    removeTask(task=this){
        Task.removeTask([task],null,true);
    }
    static removeTask(task,tasks,listenerRemove){
        let _tasks=[],total=0;
        if(task instanceof Task){
            _tasks.push(task)
        }else if(Util.isArray(task)){
            _tasks=task;
        }
        if(_tasks.length===0){
            return total
        }
        tasks=tasks||Task.tasks;
        for(let i=0;i<tasks.length;i++){
            if(Util.inArray(tasks[i],_tasks)!==-1){
                listenerRemove&&tasks[i].off();
                tasks.splice(i,1);
                i--;
                total++;
            }
        }
        return total
    }
}
class Template {
    static templates=[];
    constructor(option){
        this.templateName=option.templateName||"default";
        this.width=option.width;
        this.height=option.height;
        this.render=option.render;
        if(!Util.isFunction(this.render)&&!Util.isObject(this.render)){
            throw new Error("render必传，且必须是一个函数或者对象！")
        }
        if(!Template.getTemplate(this.templateName)){
            Template.templates.push(this);
        }
    }
    static getTemplate(name){
        if(Template.templates.length===0){
            return false
        }
        if(!name)return this.getTemplate("default");
        if(name instanceof Template){
            return name
        }
        const templates=Template.templates;
        for(let i=0;i<templates.length;i++){
            if(templates[i].templateName===name){
                return templates[i]
            }
        }
        return false
    }
    renderTask(task,LODOP){
        task.setStatus(7);
        task.templateName=this.templateName;
        LODOP.PRINT_INIT("");
        return task.emitAsync("taskBeforeRender",LODOP).then(()=>{
            let data=task.data;
            let promises=[];
            if(!Util.isArray(data)){
                data=[data]
            }
            const len=data.length;
            task.setStatus(8);
            for(let i=0;i<len;i++){
                promises=promises.concat(task.emitAsync("taskBeforeSingleRender",{data:data[i],LODOP:LODOP}));
            }
            return Promise.all(promises).then(()=>{
                LODOP.SET_PRINT_MODE('CUSTOM_TASK_NAME','第'+task.index+'批任务！,共'+len+'条数据');
                for(let i=0;i<len;i++){
                    this._render(this.render,data[i],LODOP);
                    !task.config.notAutoNewPage&&LODOP.NewPage();
                }
                task.setStatus(9);
                return task.emitAsync("taskAfterRender",LODOP)
            })
        })
    }
    _render(render,data,LODOP){
        if(Util.isFunction(render)){
            return render.call(this,{data,LODOP})
        }else if(Util.isObject(render)){
            const {width,height,conversion,intOrient,list}=render;
            LODOP.SET_PRINT_PAGESIZE(intOrient,width,height,"",conversion);
            Template._renderList(list,data,LODOP)
        }
    }
    static _renderList(list,data,LODOP){
        if(Util.isArray(list)){
            for(let i=0;i<list.length;i++){
                Util.isObject(list[i])&&Template._renderItem(list[i],data,LODOP)
            }
        }
    }
    static _renderItem(item,data,LODOP){
        const {top,left,width,height}=item;
        if(item.showed&&!Template.getValue(item.showed,data))return false;
        const value=Template.getStringValue(item.value,data);
        let fontSize=item.fontSize;
        if(item.fontSizeAuto){
            fontSize=WindowLODOP.getFontSize(width,height,{...item,value})
        }
        switch (item.type){
            case "text":
                LODOP.ADD_PRINT_TEXT(top,left,width,height,value);
                break;
            case "line":
                LODOP.ADD_PRINT_RECT(top,left,width,height,item.lineStyle,item.lineWidth,item.lineColor);
                break;
            case "html":
                LODOP.ADD_PRINT_HTM(top,left,width,height,value);
                return;
            case "image":
                LODOP.ADD_PRINT_IMAGE(top,left,width,height,"<img border='0' src='"+value+"'>");
                LODOP.SET_PRINT_STYLEA(0,"Stretch",2);
                return;
            case "QRCode":
                if(value)LODOP.ADD_PRINT_BARCODE(top,left,width,height,"QRCode",value);
                return;
            case "barCode":
                if(value){
                    LODOP.ADD_PRINT_BARCODE(top,left,width,height,item.codeType,value,3);
                    LODOP.SET_PRINT_STYLEA(0,"ShowBarText",0);
                }
                return;
            case "blackBackgroundWhiteFont":
                WindowLODOP.ADD_PRINT_BLACK_BACKGROUND_WHITE_FONT_LODOP.call(LODOP,top,left,width,height,{...item,value,fontSize});
                return;
            case "watermark":
                WindowLODOP.ADD_PRINT_WATERMARK.call(LODOP,top,left,width,height,{...item,value,fontSize});
                return;
            case "flag":
                WindowLODOP.ADD_PRINT_FLAG.call(LODOP,top,left,width,height,{...item,value,fontSize});
                return;
            default:
                return;
        }
        Template._renderItemStyle({...item,fontSize},LODOP);
    }
    static getValue(key,data){
        try {
            return new Function("__data","with(__data){return "+key+"}").call(data,data);
        }catch (err){
            return null
        }
    }
    static getStringValue(value,data){
        return Template.valueToString(value).replace(/{{(.*?)}}/g,($1,$2)=>Template.getValue($2,data)||"")
    }
    static valueToString(value){
        if(value===null||value===void 0)return "";
        return String(value)
    }
    static _renderItemStyle(item,LODOP){
        const style = {
            line:["lineStyle","lineWidth","lineColor"],
            text:["fontStyle","italic","fontFamily","color","fontWeight","textAlign","fontSize","lineHeight"]
        };
        (style[item.type]||[]).forEach(val=>{
            if(item.hasOwnProperty(val)&&item[val]!==""){
                for(let i=0;i<WindowLODOP.supports.length;i++){
                    if(WindowLODOP.supports[i].reg.test(val)){
                        LODOP.SET_PRINT_STYLEA(0,...WindowLODOP.supports[i].value.call(LODOP,item[val],true));
                        break
                    }
                }
            }
        })
    }
}
class WindowLODOP {
    isWindowLODOP = true;
    constructor(task){
        this.iframeId=Util.getId("printIframe");
        const $div=document.createElement("div");
        $div.innerHTML='<iframe id="'+this.iframeId+'" style="width: 10px;height: 10px;left: -100px;position: absolute;z-index: -1;opacity: .01" src="" frameborder="0"></iframe>';
        document.body.appendChild($div.childNodes[0]);
        task.LODOP=this;
        this.version='1.1.0';
        this.scale=1;
    }
    PRINT_INIT(){

    }
    onReady(){
        return new Promise((resolve)=>{
            if(this.document){
                resolve(this)
            }else {
                setTimeout(()=>{
                    const $iframe=document.getElementById(this.iframeId);
                    this.document=$iframe.contentDocument;
                    this.window=$iframe.contentWindow;
                    this.body=this.document.body;
                    const _style=this.document.createElement("style");
                    _style.innerHTML='html,body{margin:0;padding:0}*{box-sizing:border-box} img{max-width:100%;max-height:100%} canvas{width:100%!important;height:100%!important}';
                    this.document.head.appendChild(_style);
                    this.NewPage();
                    resolve(this)
                },50)
            }
        })
    }
    SET_PRINT_PAGESIZE(intOrient, pageWidth,pageHeight,strPageName,scale){
        const last=this.body.children[this.body.children.length-1];
        if(!isNaN(pageWidth)){
            pageWidth=0.1*Number(pageWidth)+"mm";
        }
        if(!isNaN(pageHeight)){
            pageHeight=0.1*Number(pageHeight)+"mm";
        }
        this.pageWidth=pageWidth;
        this.pageHeight=pageHeight;
        last.style.width=pageWidth;
        last.style.height=pageHeight;
        if(!isNaN(scale)){
            this.scale=10/38
        }
        if(Number(intOrient)===2){
            last.style.transform="translateX("+pageWidth+") rotate(90deg)";
            last.style.transformOrigin="left top";
        }
    }
    initStyle(printStyle){
        let newStyle='';
        let _style=this.switchStyle(printStyle);
        for(let key in _style){
            if(_style.hasOwnProperty(key)){
                newStyle+=(key+":"+(_style[key]||'initial')+";")
            }
        }
        return newStyle
    }
    aU(str,scale=this.scale){ //addUnit
        return WindowLODOP.aU(str,scale)
    }
    switchStyle(printStyle,value){
        return WindowLODOP.switchStyle.call(this,printStyle||this.printStyle,value)
    }
    swtichStyle(){
        console.info("将要废弃，单词写错了！用switchStyle。-_-");
        return this.switchStyle(...arguments)
    }
    createBlock(styleSheet,html='',addStyle=''){
        if(Util.isObject(styleSheet)){
            let {left,top,width,height}=styleSheet;
            styleSheet='left:'+this.aU(left)+';top:'+this.aU(top)+';width:'+this.aU(width)+';height:'+this.aU(height);
        }
        const $div=document.createElement("div");
        $div.innerHTML='<div style="'+this.initStyle()+styleSheet+";"+addStyle+'">'+html+'</div>';
        return $div.childNodes[0]
    }
    ADD_PRINT_HTM(top,left,width,height,html,br){
        const div=this.createBlock({top,left,width,height},html&&br&&html.replace(/[\r\n]+|(\\r|\\n)+/g,"<br>")||html);
        this.body.children[this.body.children.length-1].appendChild(div);
        return div
    }
    ADD_PRINT_TEXT(top,left,width,height,html){
        return this.ADD_PRINT_HTM(top,left,width,height,html,true);
    }
    ADD_PRINT_IMAGE(){
        return this.ADD_PRINT_HTM(...arguments);
    }
    ADD_PRINT_RECT(top, left, width, height,intLineStyle=0, intLineWidth=0,color='#000'){
        switch (Number(intLineStyle)){
            case 0:
                intLineStyle='solid';
                break;
            case 1:
                intLineStyle='dashed';
                break;
            default:
                intLineStyle='solid';
                break;
        }
        let _style=width<height&&('border-left:'+this.aU(intLineWidth)+' '+intLineStyle+' '+color)||('border-top:'+this.aU(intLineWidth)+' '+intLineStyle+' '+color);
        const div=this.createBlock({top,left,width,height},'',_style,'');
        this.body.children[this.body.children.length-1].appendChild(div);
        return div
    }
    ADD_PRINT_LINE(top, left,top2, left2,intLineStyle,intLineWidth,color){
        let unit=0;
        if(isNaN(top)){
            const wordExp=/[a-zA-Z]+/g;
            unit=top.match(wordExp);
            if(unit){
                unit=unit[0];
            }
            top=top.replace(wordExp,"");
            left=left.replace(wordExp,"");
            top2=top2.replace(wordExp,"");
            left2=left2.replace(wordExp,"");
        }
        return this.ADD_PRINT_RECT(top+unit,left+unit,left2-left+unit,top2-top+unit,intLineStyle,intLineWidth,color);
    }
    ADD_PRINT_BLACK_BACKGROUND_WHITE_FONT(){
        return WindowLODOP.ADD_PRINT_BLACK_BACKGROUND_WHITE_FONT_LODOP.call(this,...arguments)
    }
    SET_PRINT_STYLEA(index,name,value){
        if(isNaN(index)||index>0){
            return false;
        }
        const children=this.body.children;
        const page=children[children.length-1];
        const len=page.children.length;
        index=len+index-1;
        if(index<0||!page.children[index]){
            return false;
        }
        [name,value]=this.switchStyle(name,value);
        if(name){
            if(/-/.test(name)){
                let a=name.match(/-(.+?)/);
                if(a){
                    name=name.replace(a[0],String(a[1]).toUpperCase());
                }
            }
            let cur=page.children[index];
            if(cur.JBO){
                const _value=cur.JBO[0],_option=cur.JBO[1];
                _option[name]=value;
                try{
                    JsBarcode(cur.children[0],_value,_option);
                }catch (err){
                    //忽略错误，ie问题后面我再看看修复
                }
            }else {
                cur.style[name]=value||'initial';
            }
        }
        return true
    }
    SET_PRINT_STYLE(name,value){
        if(!name)return false;
        this.printStyle[name]=value;
        return true
    }
    NewPage(){
        let $div=this.document.createElement("div");
        const $style=$div.style;
        $style.pageBreakAfter='always';
        $style.position='relative';
        $style.width='1px';
        $style.height='1px';
        this.document.body.appendChild($div);
        this.printStyle={Position:"absolute"};
    }
    SET_PRINT_MODE(type,txt){
        switch (type){
            case "CUSTOM_TASK_NAME":
            default:
                this.document.title=txt;
        }
    }
    ADD_PRINT_BARCODE(top,left,width,height,type="128",value,signleWidth=3){
        let img=document.createElement("img");
        const div=this.createBlock({top,left,width,height},"");
        this.body.children[this.body.children.length-1].appendChild(div);
        if(isNaN(width)){
            width=100;
        }
        if(isNaN(height)){
            height=100;
        }
        switch (type){
            case "QRCode":
                new Qrcode({value,size:width*4,element:img});
                break;
            default:
                let format=null;
                if(!/128/.test(type)){
                    throw new Error("windowPrint下，只支持128格式的条形码");
                }
                if(!/[Aa][Uu][Tt][Oo]/.test(type)){
                    format='CODE'+type;
                }
                let _options = {format:format,width:signleWidth,height:height,displayValue:true,margin:0,fontSize:30};
                JsBarcode(img,value,_options);
                div.JBO=[value,_options];
                break;
        }
        div.appendChild(img);
    }
    removeLastEmptyPage(){
        const last=this.body.children[this.body.children.length-1];
        if(last&&last.children.length===0){
            this.body.removeChild(last);
        }
    }
    static ADD_PRINT_BLACK_BACKGROUND_WHITE_FONT_LODOP(top,left,width,height,opt){
        return this.ADD_PRINT_IMAGE(top,left,width,height,"<img src='"+WindowLODOP.toDataURL(width,height,opt,true)+"'>")
    }
    static ADD_PRINT_WATERMARK(top,left,width,height,opt){
        return this.ADD_PRINT_IMAGE(top,left,width,height,"<img src='"+WindowLODOP.toDataURL(width,height,opt)+"'>")
    }
    static ADD_PRINT_FLAG(top,left,width,height,opt){
        return this.ADD_PRINT_IMAGE(top,left,width,height,"<img src='"+WindowLODOP.toDataURL(width,height,opt)+"'>")
    }
    static toDataURL(width,height,opt){
        const canvas = document.createElement('canvas');
        if (!canvas.getContext("2d")) return "";
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        const textAlign=WindowLODOP.switchStyle("Alignment",opt.textAlign)[1]||"center";
        let fontSize=opt.fontSize,unit;
        [fontSize,unit]=WindowLODOP.splitUnit(fontSize);
        unit=unit||"px";
        ctx.font = fontSize+unit+" "+(opt.fontFamily || "微软雅黑");
        ctx.textAlign = textAlign;
        ctx.textBaseline = 'middle';
        ctx.fillStyle = opt.color||"#000";
        let value=String(opt.value);
        let lineHeight=opt.lineHeight?Number(opt.lineHeight):1.2*ctx.measureText("大").width;
        let startY=lineHeight/2;
        let startX=textAlign==="right"?width-2:textAlign==="center"?0.5*width:2;
        value.split(/\\n|\n/g).forEach(value=>{
            let len =value.length;
            while (len){
                let curValue=value.slice(0,len);
                if(curValue.length>1&&ctx.measureText(curValue).width>width-4){
                    len--;
                }else {
                    ctx.fillText(curValue,startX,startY);
                    if(len<value.length){
                        startY+=lineHeight;
                        value=value.slice(len);
                        len=value.length;
                    }else {
                        break
                    }
                }
            }
            startY+=lineHeight;
        });
        if(opt.type==='blackBackgroundWhiteFont'){
            ctx.globalCompositeOperation = "source-out";
            ctx.fillStyle = "#000";
            ctx.fillRect(0, 0, opt.width, opt.height);
        }
        if(opt.type==='flag'){
            ctx.arc(width/2,width/2,width*0.45,0,Math.PI*2);
            ctx.lineWidth=opt.lineWidth;
            ctx.strokeStyle=opt.lineColor;
            ctx.stroke();
        }
        return canvas.toDataURL();
    }
    static aU(str,scale){
        if(!isNaN(str)){
            return Number(str)*(scale||this.scale)+"mm";
        }
        if(!str)return 'initial';
        return str;
    }
    static supports=[
        {
            reg:/^[Ff]ont[-]?([Nn]ame|[Ff]amily)$/,
            value(value,isLodop){
                return [isLodop?"FontName":"font-family",value]
            }
        }, {
            reg:/^[Pp]osition$/,
            value(value,isLodop){
                return [isLodop?"Position":"position",value]
            }
        }, {
            reg:/^([Ff]ont)?-?[Cc]olor$/,
            value(value,isLodop){
                return [isLodop?"FontColor":"color",value]
            }
        },{
            reg:/^[Bb]old|[Ff]ont[-]?[Ww]eight$/,
            value(value,isLodop){
                let newValue;
                if(!value){
                    newValue=0
                }else if(typeof value==="boolean"){
                    newValue=value?1:0
                }else if(!isNaN(value)){
                    newValue=Number(value);
                    newValue=newValue*newValue===newValue?newValue:newValue>=900?1:0;
                }else {
                    newValue=value==='bold'?1:newValue
                }
                newValue=isLodop?newValue:newValue===0?'400':newValue===1?'bold':newValue;
                return [isLodop?"Bold":"font-weight",newValue]
            }
        },{
            reg:/^[Ii]talic|[Ff]ont[-]?[Ss]tyle$/,
            value(value,isLodop){
                let newValue;
                if(!value){
                    newValue=0
                }else if(typeof value==="boolean"){
                    newValue=value?1:0
                }else if(!isNaN(value)){
                    newValue=Number(value);
                    newValue=newValue*newValue===newValue?newValue:0;
                }else {
                    newValue=value==='italic'?1:value==='none'?0:newValue
                }
                newValue=isLodop?newValue:newValue===1?'italic':newValue===0?'none':newValue;
                return [isLodop?"Italic":"font-style",newValue]
            }
        },{
            reg:/^[Aa]lignment|[tT]ext[-]?[aA]lign$/,
            value(value,isLodop){
                let newValue;
                if(!value){
                    newValue=1
                }else if(!isNaN(value)){
                    newValue=Number(value);
                }else {
                    newValue=value==='right'?3:value==='center'?2:value==='left'?1:newValue;
                }
                newValue=isLodop?newValue:newValue===3?'right':newValue===2?'center':newValue===1?'left':newValue;
                return [isLodop?"Alignment":"text-align",newValue]
            }
        },{
            reg:/^[Ff]ont[-]?[sS]ize$/,
            value(value,isLodop){
                return [isLodop?"FontSize":"font-size",this.aU?this.aU(value):value]
            }
        },{
            reg:/^[Ll]ine[-]?([hH]eight|[Ss]pacing)$/,
            value(value,isLodop){
                return [isLodop?"LineSpacing":"line-height",this.aU?this.aU(value):value]
            }
        },{
            reg:/^[Ss]how[-]?[Bb]ar[-]?[Tt]ext|[dD]isplay[-]?[Vv]alue$/,
            value(value,isLodop){
                return [isLodop?"ShowBarText":"display-value",!!value]
            }
        }
    ];
    static switchStyle(printStyle,value){
        printStyle=printStyle||this.printStyle;
        const newStyle={};
        const supports=WindowLODOP.supports;
        if(typeof printStyle==='string'){
            for(let i=0;i<supports.length;i++){
                if(supports[i].reg.test(printStyle)){
                    return supports[i].value.call(this,value)
                }
            }
            return []
        }
        for(let key in printStyle){
            if(printStyle.hasOwnProperty(key)){
                for(let i=0;i<supports.length;i++){
                    if(supports[i].reg.test(key)){
                        let [name,value]=supports[i].value.call(this,printStyle[key]);
                        newStyle[name]=value;
                    }
                }
            }
        }
        return newStyle
    }
    static getFontSize(width,height,opt){
        const canvas = document.createElement('canvas');
        if (!canvas.getContext("2d"))return 12;
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        let fontSize=opt.fontSize||"12px",unit;
        [fontSize,unit]=WindowLODOP.splitUnit(fontSize);
        unit=unit||"px";
        ctx.font = "bold " + fontSize + unit+"  "+opt.fontFamily;
        while ((ctx.measureText(opt.value).width) > width) {
            fontSize = fontSize - 1;
            ctx.font = "bold " + fontSize + unit+" "+opt.fontFamily;
        }
        return fontSize + unit;
    }
    static splitUnit(str){
        const wordExp=/[a-zA-Z]+/g;
        let unit=str.match(wordExp);
        if(unit){
            unit=unit[0];
            str=str.replace(wordExp,"");
        }
        return [str,unit]
    }
}
class Print extends Dispatcher{
    static id=Util.getId();
    static version = '4.0.2';
    static author = '348776';
    /** @namespace config.forceLODOP */
    constructor(option){
        option=option||{};
        super(option);
        this.prevId=Print.id;
        const config=this.config={
            driveURL:['http://localhost:18000/CLodopfuncs.js?priority=0','http://localhost:8000/CLodopfuncs.js?priority=1','https://localhost:8443/CLodopfuncs.js?priority=1'],
            splitLength:5,
            maxTasksLength:500,
            notUseLODOP:false,
            timeOut:4000,
            templateBaseUrl:"http://ca.deppon.com/pcs/",
            systemName:""
        };
        this.tasks=[];
        this.id=this.prevId+"."+Util.getId();
        this.options=option;
        this.onByObject(this.options);
        this.setConfig(option.config);
        setTimeout(()=>{
            if (config.notUseLODOP) {
                this.emit('mounted');
            }else if(!Print.LODOP){
                this.emit('beforeBuild');
                if(config.forceLODOP){
                    this.build(true);
                }else {
                    buildLODOP(config.driveURL,config.timeOut).then(() => {
                        this.emit('afterBuild');
                        this.build();
                    }).catch(errorText => {
                        this.emit('afterBuild');
                        this.build(null,errorText);
                    })
                }
            }else {
                this.LODOP = Print.LODOP;
                this.used=this.LODOP.CVERSION&&'CLODOP'||'LODOP';
                this.emit('mounted');
            }
        },0)
    }
    setConfig(config){
        if(!Util.isObject(config)){
            return false;
        }
        for(let key in config){
            if(config.hasOwnProperty(key)){
                this.config[key]=config[key]
            }
        }
    }
    build(forceLODOP,errorText){
        const conf=this.config;
        let data=null;
        let success=(data,useCLODOP)=>{
            if(data.success){
                this.used=useCLODOP&&'CLODOP'||'LODOP';
                let LODOP=data.LODOP;
                Print.LODOP = this.LODOP = LODOP;
                LODOP.On_Return_Remain = true;
                LODOP.SET_PRINT_MODE('CATCH_PRINT_STATUS',true);
                LODOP.On_Return = Print.onReturn;
                LODOP.ADD_PRINT_BLACK_BACKGROUND_WHITE_FONT=WindowLODOP.prototype.ADD_PRINT_BLACK_BACKGROUND_WHITE_FONT;
                this.emit('mounted');
            }else {
                if(this.emit('errorBuild',errorText).length===0){
                    renderConfig.notInstall();
                }
            }
        };
        if(conf.forceLODOP){
            getLODOP().then(success);
        }else {
            data=getCLODOP();
            if(conf.forceCLODOP||data.success){
                success(data,true);
            }else {
                getLODOP().then(success);
            }
        }
    }
    removeTask(tasks,all){
        Task.removeTask(tasks,this.tasks);
        if(all)Task.removeTask(tasks,null,true);
    }
    reset(){
        this.removeTask(this.tasks);
    }
    push(option={},start){
        if(!Util.isObject(option)){
            throw '参数只能是对象！';
        }
        const _task=new Task(Object.assign({
            type:'print',
            dependency:!start&&this.tasks.length>0&&this.tasks[this.tasks.length-1],
            config:this.config,
            prevId:this.id,
            detachData:({tasks,task})=>{
                if(!tasks)return false;
                task=task||_task;
                for(let i=0,len=tasks.length;i<len;i++){
                    let cur=tasks[i];
                    cur.status=task.status>0&&1||0;
                    this.tasks.push(cur);
                }
                task.insert(tasks)
            }
        },option));
        this.tasks.push(_task);
        return _task;
    }
    print(option,start){
        let tasks;
        if(Util.isObject(option)){
            if(!(option instanceof Task)){
                tasks=[this.push(option,start)];
            }else {
                tasks=[option]
            }
        }
        if(!start){
            tasks=this.getTasksByStatus(0)
        }
        return this.printTasks(tasks,start);
    }
    printTasks(tasks,start){
        const id=Util.getId();
        return new Promise(resolve=>{
            tasks=tasks||this.getTasksByStatus(0);
            const first=tasks[0];
            if(first){
                let index=1;
                this.onLODOPReady().then(()=>{
                    let last=tasks[tasks.length-1];
                    tasks.forEach((task)=>{
                        task.index=index;
                        index++;
                        task.batchId=id;
                        task.setStatus(1);
                        task.emit("taskReady",task);
                    });
                    last.on("taskComplete",()=>{
                        resolve(tasks);
                        setTimeout(()=>{this.freeMemory()},1)
                    },true,false);
                    if(start||!first.dependency||first.dependency.status>10){
                        Task.queue(first);
                    }
                }).catch(err=>{this.emit("taskErrorPrint",err)});
            }
        });
    }
    onLODOPReady(){
        return new Promise((resolve,reject)=>{
            if(this.config.notUseLODOP){
                return resolve(this.LODOP);
            }
            const LODOP=this.LODOP;
            if(LODOP){
                if(LODOP.webskt&&LODOP.webskt.readyState===1||!LODOP.CVERSION){
                    resolve(LODOP)
                }else {
                    let total=0;
                    const timer=setInterval(()=>{
                        total++;
                        if(LODOP.webskt&&LODOP.webskt.readyState===1){
                            clearInterval(timer);
                            resolve(LODOP)
                        }
                        if(total>10){
                            clearInterval(timer);
                            reject("加载LODOP WebSocket超时")
                        }
                    },100)
                }
            }else {
                this.on("mounted",()=>{this.onLODOPReady().then(()=> {
                    resolve(LODOP);
                })})
            }
        });
    }
    getTasksByStatus(status){
        const arr=[];
        const tasks=this.tasks;
        for(let i=0;i<tasks.length;i++){
            if(tasks[i].status===status){
                arr.push(tasks[i]);
            }
        }
        return arr;
    }
    throwLODOPNotReady(){
        if(!this.LODOP){
            throw new Error("请在mounted函数内调用，或者等LODOP加载完毕后调用！或者使用new Print().onLODOPReady().then()方式调用");
        }
    }
    getPrinter(){
        this.throwLODOPNotReady();
        const arr=[];
        for (let i = 0,len=this.LODOP.GET_PRINTER_COUNT(); i < len; i++) {
            arr.push(this.LODOP.GET_PRINTER_NAME(i));
        }
        return arr
    }
    getPrinterName(index) {
        this.throwLODOPNotReady();
        index=Number(index);
        if(isNaN(index)){
            index=-1;
        }

        return this.LODOP.GET_PRINTER_NAME(index)
    }
    addTemplate(option){
        return new Template(option,this.id);
    }
    freeMemory(){
        if(this.tasks.length>this.config.maxTasksLength){
            const tasks=[];
            const max = this.config.maxTasksLength/2;
            let total=0;
            for(let i=0,len=this.tasks.length;i<len;i++){
                if(this.tasks[i].isComplete()){
                    total++;
                    tasks.push(this.tasks[i]);
                    if(total>max)break;
                }
            }
            this.removeTask(tasks,true);
        }
    }
    execute(jsCode){
        return Print.execute(jsCode,this)
    }
    loadTemplate(url,version){
        url=url||"baseTemplate.js";
        if(!/^http/.test(url)){
            url=this.config.templateBaseUrl+this.config.systemName+"/"+url.replace(/\.js$/g,"")+".js";
        }
        return this.loadScript(url,"_DPrintLoadTemplate",version).then(data=>{
            if(!data)return;
            if(!Util.isArray(data))data=[data];
            return data.map(val=>this.addTemplate(val))
        });
    }
    loadPlugin(type,id,version){
        id=id.replace(/\.js$/g,"");
        let url=/^http/.test(type)?type:this.config.templateBaseUrl+this.config.systemName+"/"+type+"/"+id+".js";
        return this.loadScript(url,"_DPrintLoadPlugin",version).then(data=>{
            return typeof data==='string'?this.execute(data):typeof data==='function'?data.call(this):data
        });
    }
    loadScript(url,callbackName,version){
        if(version){
            url+=(/\?/.test(url)?'&':'?')+"q="+encodeURIComponent(version)
        }
        return new Promise((resolve,reject)=>{
            const script=document.createElement("script");
            script.src=url;
            script.async = false;
            script.type="text/javascript";
            const callbacksName=callbackName+"s";
            window[callbacksName]=window[callbacksName]||[];
            window[callbacksName].push(resolve);
            if(!window[callbackName]){
                window[callbackName]=(data)=> {
                    window[callbacksName].splice(0,1)[0](data);
                    if(window[callbacksName].length===0){
                        delete window[callbacksName];
                        delete window[callbackName];
                    }
                };
            }
            script.onload=()=>{document.head.removeChild(script)};
            script.onerror=()=>{
                window[callbacksName]=window[callbacksName].filter(val=>resolve!==val);
                if(window[callbacksName].length===0){
                    delete window[callbacksName];
                    delete window[callbackName];
                }
                reject()
            };
            document.head.appendChild(script)
        })
    }
    static onReturn(taskId,value){
        const tasks=Task.tasks;
        for(let i=0,len=tasks.length;i<len;i++){
            let cur=tasks[i];
            if(cur.taskId===taskId){
                cur.complete(tasks[i],value);
                break
            }
        }
    }
    static execute(jsCode,scope=this){
        let result;
        try {
            result = new Function("DPrint",jsCode).call(scope,Print)
        }catch (err){
            scope.emit("errorExecute",err);
            console.error(err);
        }
        return result
    }
    static WindowLODOP=WindowLODOP;
    static Promise = Promise;
    static Dispatcher = Dispatcher;
    static Task = Task;
    static Template = Template;
    static Util = Util;
    static JsBarcode = JsBarcode;
    static Qrcode = Qrcode;
}
window._DPrint=Print;
export default Print
